/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {useAuth} from '../../../../app/modules/auth'
//import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import Swal from 'sweetalert2'
import {useLocation, useNavigate} from 'react-router-dom'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  // toAbsoluteUrl('/media/avatars/blank.png')
  const DEFAULT_AVATAR = '/media/svg/avatars/blank.svg'
  const API_URL = process.env.REACT_APP_API_URL + '/api/profile/photo'

  const [avatarPreview, setAvatarPreview] = useState<string>(() => {
    return currentUser?.profilePhoto ? API_URL : toAbsoluteUrl(DEFAULT_AVATAR)
  })

  const confirmExit = async () => {
    await Swal.fire({
      text: 'Deseja sair da aplicação!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      customClass: {
        confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
        cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
      },
    }).then((result) => {
      if (result.isConfirmed) {
        logout()
      }
    })
  }

  const selectUnid = async () => {
    await Swal.fire({
      text: 'Deseja alterar a unidade?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      customClass: {
        confirmButton: 'btn btn-danger', // Classe personalizada para o botão de confirmação
        cancelButton: 'btn btn-secondary', // Classe personalizada para o botão de cancelamento (opcional)
      },
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(`../auth/franquias`)
      }
    })
  }

  const selectMyProfile = () => {
    const path = location.pathname
    if (path.startsWith('/kpi')) {
      navigate('/kpi/userProfile')
    } else {
      navigate('/userProfile')
    }
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-danger fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={avatarPreview} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>{currentUser?.name}</div>
            <a
              href='#'
              className='fw-bold text-muted text-hover-danger fs-7'
              style={{
                maxWidth: '220px',
                display: 'inline-block',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
              }}
            >
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>
      <div className='menu-item px-5'>
        <a onClick={selectMyProfile} className='menu-link px-5'>
          Meu Perfil
        </a>
        <a onClick={selectUnid} className='menu-link px-5'>
          Selecionar unidade
        </a>
        <a onClick={confirmExit} className='menu-link px-5'>
          Sair
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
